import PropTypes from "prop-types";
import Modal from "@shared/v2/Modal";
import TaskForm from "./TaskForm";

const TaskModal = ({
  onClose,
  contactEmail = "",
  getCardTasks = undefined,
  isCreatingAppointment = false,
  listingUuid = undefined,
  person = undefined,
  setOpenAddAgreementModal = undefined,
  showTaskFor = false,
  taskFor = undefined,
  task = undefined,
  taskable = undefined,
  updateTask,
  user = undefined,
  v4TaskApi = false,
  ...props
}) => (
  <Modal
    id="add-task-modal"
    show
    onHide={onClose}
    dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
    contentClassName="tw-max-w-[750px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    <TaskForm
      showHeader
      agreementCallBack={setOpenAddAgreementModal}
      onClose={onClose}
      contactEmail={contactEmail}
      getCardTasks={getCardTasks}
      isCreatingAppointment={isCreatingAppointment}
      listingUuid={listingUuid}
      person={person}
      showTaskFor={showTaskFor}
      taskFor={taskFor}
      task={task}
      taskable={taskable}
      updateTask={updateTask}
      user={user}
      v4TaskApi={v4TaskApi}
    />
  </Modal>
);

TaskModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  contactEmail: PropTypes.string,
  getCardTasks: PropTypes.func,
  isCreatingAppointment: PropTypes.bool,
  listingUuid: PropTypes.string,
  person: PropTypes.shape(),
  setOpenAddAgreementModal: PropTypes.func,
  showTaskFor: PropTypes.bool,
  taskFor: PropTypes.shape(),
  task: PropTypes.shape(),
  taskable: PropTypes.shape(),
  updateTask: PropTypes.func.isRequired,
  user: PropTypes.shape(),
  v4TaskApi: PropTypes.bool,
};

export default TaskModal;
